import { Ad } from "src/app/models/ad";
import { TransactionType } from "src/app/models/transactionType";

export class AdManagementHelper {
    public static ConvertReponseToAdArray(response: any): Ad[] {
        const items = response.json().Items as any[];
        return items.map(data => Ad.createAdFromJsonObject(data));
    }
    
    public static AdLookup(id: string): (reponse: any) => Ad {
        return response =>
            AdManagementHelper.ConvertReponseToAdArray(response)
                .filter(ad => ad.id === id)[0];
    }

    public static FilterPublicAds(transactiontype: TransactionType, estatetype: string): (reponse: any) => Ad[] {
        return response =>
            AdManagementHelper.ConvertReponseToAdArray(response)
                .filter(ad =>
                    ad.transactiontype === TransactionType[transactiontype]
                    && AdManagementHelper.estateTypeCompatible(ad, estatetype)
                    && ad.visible);
    }

    private static estateTypeCompatible(ad: Ad, estatetype: string) {
        return estatetype == null
            || ad.estatetype.toLocaleLowerCase().indexOf(estatetype.toLocaleLowerCase()) != -1
            || (estatetype.toLocaleLowerCase() === 'appartement'
                && ad.estatetype.toLocaleLowerCase().indexOf('studio') != -1);
    }
}
